import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mutara-empty-link',
    template: '<div>Broken Link</div>',
    styleUrls: ['../../assets/global-settings.scss'],
    standalone: false
})
export class EmptyLinkComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
